<template>
<v-container>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-flex xs12 md44 class="my-3">

      <div class="text-xs-center">
        <img src="https://sendgrid.kke.co.jp/images/common/logo.svg" style="margin-top: 40px;"/>

        <p style="margin-top: 30px;font-size: 16px;">
        審査のほど、よろしくお願いいたします。
        </p>

      </div>


    </v-flex>

    </v-flex>
  </v-layout>
</v-container>
</template>


<script>
export default {
  data () {
    return {
    }
  }
}

</script>

<style>
.ah-regal-head {
    margin-bottom: 0px;
    font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/components/Sendgrid.vue